var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 12.4998C3.33334 12.4998 4.16668 11.6665 6.66668 11.6665C9.16668 11.6665 10.8333 13.3332 13.3333 13.3332C15.8333 13.3332 16.6667 12.4998 16.6667 12.4998V2.49984C16.6667 2.49984 15.8333 3.33317 13.3333 3.33317C10.8333 3.33317 9.16668 1.6665 6.66668 1.6665C4.16668 1.6665 3.33334 2.49984 3.33334 2.49984L3.33334 18.3332",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.0d0e7431d1b54ec18d6e84e4e49529d2.svg";
export { ForwardRef as ReactComponent };